import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Alert } from '@mui/material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import * as common from '../../../commons/common';
import PrivacyPolicy from './privacyPolicy';

export default function SafetyCheckForm() {
    const navigate = useNavigate();
    const { noticeId } = useParams();

    const [formData, setFormData] = useState({
        organizationNm: '',
        name: '',
        ssn: '',
    });
    const [agreeCollection, setAgreeCollection] = useState(false);
    const [isOpenPolicyModal, setIsOpenPolicyModal] = useState(false)
    const [formAlert, setAlert] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${common.getApiUrl()}/qr/notice/${noticeId}`, {
                    headers: {
                        // Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.data) {
                    navigate(`/safetyIntro`);
                }
            } catch (error) {
                navigate(`/safetyIntro`);
            }
        };
        fetchData();
    })

    const handleAgreeBtn = () => {
        setAgreeCollection((prev) => !prev);
    }

    const handleOpenPolicyModal = () => {
        setIsOpenPolicyModal(true);
    }

    const handleClosePolicyModal = () => {
        setIsOpenPolicyModal(false);
    }

    const handleEnter = () => {
        if (!formData.organizationNm) {
            setAlert('소속명을 입력해주세요');
            return;
        } else if (!formData.name) {
            setAlert('성명을 입력해주세요');
            return;
        } else if (!formData.ssn || formData.ssn.length !== 8) {
            setAlert('생년월일 8자리를 정확히 입력해주세요');
            return;
        } else if (!agreeCollection) {
            setAlert('개인정보 수집·이용에 동의해주세요');
            return;
        } else {
            setAlert('');
            const { ssn, ...dataToSend } = formData;
            const modifiedData = { ...dataToSend, ssn: ssn.slice(2) };
            navigate(`/safetyGuide/${noticeId}`, { state: modifiedData });
        }
    };

    const handleNumberChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        if (numericValue.length <= 8) {
            setFormData({ ...formData, ssn: numericValue });
        }
    };

    return (
        <Box sx={{
            height: '100vh',
            bgcolor: 'var(--main-white-color)',
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '0 20px',
                justifyContent: 'center',
                height: '100%',
            }}>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '10px'
                }}>
                    <Typography variant='subtitle2' sx={{ marginBottom: '20px', fontWeight: 'bold' }}>
                        공연장 안전수칙 교육이수 확인
                    </Typography>
                    <Typography variant='h6' sx={{ marginBottom: '10px', fontWeight: 'bold' }}>
                        공연장 안전수칙 교육이수 확인을 위해<br />
                        소속명, 성명, 생년월일을 입력해주세요.
                    </Typography>
                </Box>
                <Box sx={{ marginBottom: '20px', position: 'relative' }} onClick={handleOpenPolicyModal}>
                    <Typography sx={{ fontSize: '1.2rem' }} >
                        개인정보 수집·이용에 동의합니다.<br />
                    </Typography>
                    <Typography variant='caption'>
                        입력하신 정보는 이수 확인 용도로만 사용되며,<br />
                        안전하게 관리됩니다.
                    </Typography>
                    <ArrowForwardIosIcon sx={{
                        position: 'absolute',
                        top: 10,
                        right: 0,
                        fontSize: '1.2rem'
                    }}></ArrowForwardIosIcon>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '15px' }}>
                    <Button
                        variant="contained"
                        onClick={handleAgreeBtn}
                        disableElevation
                        sx={{
                            backgroundColor: agreeCollection ? 'var(--main-blue-color) !important' : 'var(--sub-mediumgrey-color) !important',
                            paddingX: '28px'
                        }}
                    >
                        동의함
                    </Button>
                </Box>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    marginBottom: '50px'
                }}>
                    <Box sx={{ marginBottom: '12px', width: '100%' }}>
                        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
                            소속명 <span style={{ color: 'var(--main-blue-color)' }}>*</span>
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            autoComplete='off'
                            value={formData.organizationNm}
                            onChange={(e) => setFormData({ ...formData, organizationNm: e.target.value })}
                            InputProps={{ style: { borderRadius: '10px', backgroundColor: '#fff', border: '1px solid #fff' } }}
                            sx={{
                                input: { padding: '10px 15px' },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: 'none',
                                }
                            }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: '12px', width: '100%' }}>
                        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
                            성명 <span style={{ color: 'var(--main-blue-color)' }}>*</span>
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            autoComplete='off'
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            InputProps={{ style: { borderRadius: '10px', backgroundColor: '#fff', border: '1px solid #fff' } }}
                            sx={{
                                input: { padding: '10px 15px' },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: 'none',
                                }
                            }}
                        />
                    </Box>
                    <Box sx={{ marginBottom: '12px', width: '100%' }}>
                        <Typography variant="body2" component="span" sx={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
                            생년월일 <span style={{ color: 'var(--main-blue-color)' }}>*</span>
                        </Typography>
                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                autoComplete='off'
                                value={formData.ssn}
                                onChange={handleNumberChange}
                                inputProps={{ 
                                    maxLength: 8,
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*'
                                }}
                                InputProps={{ 
                                    style: { 
                                        borderRadius: '10px', 
                                        backgroundColor: '#fff', 
                                        border: '1px solid #fff',
                                        lineHeight: 'normal',
                                    } 
                                }}
                                sx={{
                                    input: { padding: '10px 15px', height: '1.5em' },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: 'none',
                                    }
                                }}
                                placeholder='YYYYMMDD'
                            />
                        </Box>
                    </Box>
                    {formAlert && (
                        <Alert severity="warning">
                            {formAlert}
                        </Alert>
                    )}
                </Box>
                <Box sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <Button
                        variant="contained"
                        onClick={handleEnter}
                        sx={{
                            backgroundColor: 'var(--main-blue-color)',
                            padding: '7px 35px',
                            fontSize: '1.4rem',
                            borderRadius: '30px',
                            boxShadow: 'none',
                        }}
                    >
                        작성완료
                    </Button>
                </Box>
            </Box>
            <PrivacyPolicy open={isOpenPolicyModal} onClose={handleClosePolicyModal} />
        </Box>
    );
}